import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/rootReducer';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

const storeCreation = () => {
  const configureStore = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk)),
  );

  // Configure redux for hot-reload development
  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers/rootReducer', () => {
        configureStore.replaceReducer(rootReducer);
      });
    }
  }
  return configureStore;
};

const store = storeCreation();

export default store;
